export const HEADER_5_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Contact rows",
  },

  DEFAULT_ROW: {
    id: "1",
    contact_row_label: "",
    contact_row_icon: "",
    contact_row_icon_alt: "",
    phone_display: "",
    priority: 1,
    status: true,
  },

  METADATA_FIELDS: [
    {
      header: "Label",
      fieldName: "contact_row_label",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Indian Nationals",
    },
    {
      header: "Row icon",
      fieldName: "contact_row_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload flag / logo",
    },
    {
      header: "Icon alt text",
      fieldName: "contact_row_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Accessibility label for icon",
    },
    {
      header: "Phone",
      fieldName: "phone_display",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Number shown and used for call link (e.g. 1800 210 2020)",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Sort order (lower first)",
      required: false,
      defaultValue: 1,
    },
    {
      header: "Row status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show this row",
      defaultValue: true,
    },
  ],

  HEADER_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Bar background color",
      value: "",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Leave empty to use theme secondary (bg-secondary-main)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "pill_background_color",
      label: "Pill / chip background",
      value: "rgba(255, 255, 255, 0.1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "e.g. rgba(255,255,255,0.1)",
      required: false,
      defaultValue: "rgba(255, 255, 255, 0.1)",
    },
    {
      fieldName: "label_text_color",
      label: "Label text color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "phone_text_color",
      label: "Phone link color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "phone_icon",
      label: "Phone icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Overrides default phone glyph when set",
    },
    {
      fieldName: "phone_icon_alt",
      label: "Phone icon alt text",
      value: "Phone",
      valueType: "string",
      filedType: "INPUT",
    },
    {
      fieldName: "show_logo",
      label: "Show logo (left side)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "logo_image",
      label: "Logo image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload logo shown on the left when Show logo is on",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "show_apply_button",
      label: "Show apply button (right side)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "apply_button_text",
      label: "Apply button text",
      value: "Apply",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Button label (opens lead capture popup on click)",
      required: false,
      defaultValue: "Apply",
    },
    {
      fieldName: "show_on_mobile",
      label: "Show on mobile (default: large screens only)",
      value: false,
      valueType: "boolean",
      filedType: "SWITCH",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "sticky_to_top",
      label: "Stick to top on scroll",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "SWITCH",
      placeholder: "Toggle status",
      required: false,
      defaultValue: true,
    },
  ],
};
